/** @deprecate use app/shared/rental-manager/constants/FaqConstants.js */

import React from 'react';
import Link from '@zg-rentals/multibrand-ui/lib/Link';

import StringConstants from '@common/constants/StringConstants';

const faqs = {
  LANDLORD_RENT_AMOUNT_CHANGE: {
    title: 'You may be wondering...',
    body: (nextAllowedChangeDate: string | Date) => [
      {
        question: `What if my tenant agreed to have the change take effect before ${nextAllowedChangeDate}?`,
        answer:
          "Since your tenant's earlier rent payments are already paid or in progress, please collect " +
          'any outstanding balance offline.',
      },
    ],
  },
  PAYMENT_INFO_RACHEL: {
    title: 'You may be wondering...',
    body: [
      {
        question: 'Is my information secure on your site?',
        answer: `We take security seriously. We use multiple layers of security to keep your
            data safe and continually update our practices to address evolving threats.`,
      },
      {
        question: 'What is a move-in payment?',
        answer: `These are typically for costs that the landlord collects one time, before the renter gets
            their keys. Move-in costs can include a security deposit, prorated rent or other one-time fees.`,
      },
    ],
  },
  PAYMENT_INFO_RACHEL_BILLING_ADDRESS: {
    title: 'You may be wondering...',
    body: [
      {
        question: 'Why do you need my address and phone number?',
        answer: `This info helps us verify your identity for your own protection. We do not sell or rent your
            personal data to marketers or unaffiliated third parties.`,
      },
    ],
  },
  MOVE_IN_COSTS_SCHEDULING_PAGE: {
    title: 'You may be wondering...',
    body: () => [
      {
        question: 'Do I need to pay the move-in costs all at once?',
        answer: `Right now, our service only supports paying for move-in costs
                in a single payment. If that isn't possible for you, speak with your landlord.
                They have the option of splitting up the charges using one-time payments.`,
      },
      {
        question: 'When will my payment arrive?',
        answer: `We'll notify your landlord when you make your payment. Depending on
                the banks' processing times, the payment will get deposited in their account
                3-5 business days later.`,
      },
    ],
  },
  ONE_TIME_PAYMENT_IRENE: {
    title: 'You may be wondering...',
    body: [
      {
        question: 'How is this different from a rent payment?',
        answer: `These payments are meant to be for other expenses covered by your lease, such as utility
                costs. They're separate from rent, and must be requested individually.`,
      },
      {
        question: "Why can't I request one-time payments as often and for as much as I'd like?",
        answer: `One-time payment requests should only be for expenses covered by your lease. Placing
                limits on them is one way that we strive to avoid improper use of our service.`,
      },
    ],
  },
  ONE_TIME_PAYMENT_RACHEL: {
    title: 'You may be wondering...',
    body: [
      {
        question: 'How is this different from rent?',
        answer: `This is a separate one-time payment requested by your landlord. Please contact
                them directly if the request seems incorrect.`,
      },
    ],
  },
  PHONE_VERIFICATION: {
    title: 'You may be wondering...',
    body: [
      {
        question: 'What if I never got a code?',
        answer: (
          <>
            Please&nbsp;
            <Link href={StringConstants.LINKS.SUPPORT_PAGE.LANDLORD} target="_blank">
              contact us
            </Link>
            , and we&apos;ll be happy to help sort this out.
          </>
        ),
      },
    ],
  },
  EDIT_PAYMENT_INFO_RACHEL: {
    title: 'You may be wondering...',
    body: [
      {
        question: 'Why did my payment fail?',
        answer: `Check your payment account if the info recently changed.
                It may be possible to resolve this issue by re-entering your bank account credentials,
                or switching to a new account.`,
      },
    ],
  },
};

export default faqs;
